import { Tabs } from '@lmc/ui-kit'
import { TabsProps } from 'antd'
import { DrawerAbout } from './DrawerAbout'
import { DrawerAllocatedTeam } from './DrawerAllocatedTeam'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type DrawerBodyProps = {
  revisionDetail: any
  onTabChange?: (key: string) => void
  defaultTab?: number
}

export const DrawerBody: FC<DrawerBodyProps> = ({
  revisionDetail,
  onTabChange,
  defaultTab,
}) => {
  const { t } = useTranslation()

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('ABOUT'),
      children: <DrawerAbout revisionDetail={revisionDetail} />,
    },
    {
      key: '2',
      label: t('TEAM_DETAILS'),
      children: <DrawerAllocatedTeam revisionDetail={revisionDetail} />,
    },
  ]

  return (
    <div>
      <Tabs
        defaultActiveKey={defaultTab?.toString()}
        items={items}
        onChange={onTabChange}
        size="large"
      />
    </div>
  )
}
